<form [formGroup]="form.formGroup">
  <p-fieldset legend="Tuning Parameters for Peng-Robinson EOS">
    <div class="flex space-x-2">
      <div class="flex flex-col">
        <label for="acor">ACOR</label>
        <app-validated-number-input
          [id]="'acor'"
          [control]="control('acor')"
          [value]="control('acor').value"
          [validation]="{ min: 0, max: 10000000 }"
        ></app-validated-number-input>
      </div>
      <div class="flex flex-col">
        <label for="bcor">BCOR</label>
        <app-validated-number-input
          [id]="'bcor'"
          [control]="control('bcor')"
          [value]="control('bcor').value"
          [validation]="{ min: 0, max: 10000000 }"
        ></app-validated-number-input>
      </div>
      <div class="flex flex-col">
        <label for="vcor">VCOR</label>
        <app-validated-number-input
          [id]="'vcor'"
          [control]="control('vcor')"
          [value]="control('vcor').value"
          [validation]="{ min: 0, max: 10000000 }"
        ></app-validated-number-input>
      </div>
      <div class="flex flex-col">
        <label for="dcor">DCOR</label>
        <app-validated-number-input
          [id]="'dcor'"
          [control]="control('dcor')"
          [value]="control('dcor').value"
          [validation]="{ min: 0, max: 10000000 }"
        ></app-validated-number-input>
      </div>
      <div class="flex flex-col">
        <label for="scor">SCOR</label>
        <app-validated-number-input
          [id]="'scor'"
          [control]="control('scor')"
          [value]="control('scor').value"
          [validation]="{ min: 0, max: 10000000 }"
        ></app-validated-number-input>
      </div>
    </div>
  </p-fieldset>

  <p class="mt-2 mb-2 text-xs">Correlation option to initialize binary Interaction K-Values:</p>

  <div class="flex flex-col">
    <label for="kiOption">K<span class="text-xs align-baseline">i</span>&nbsp;Option</label>
    <app-validated-number-input
      [id]="'kiOption'"
      [control]="control('kiOption')"
      [value]="control('kiOption').value"
      [validation]="{ min: 0, max: 10000000 }"
    ></app-validated-number-input>
  </div>

  <p class="mt-2 mb-2 text-xs">Correlation options for C<span class="text-xs align-baseline">7</span> + component critical properties, acentric
    and shift factors and binary interaction parameters:
  </p>

  <div class="flex flex-col">
    <label for="c7PlusCorrelations">C<span class="text-xs align-baseline">7</span> + Correlations</label>
    <app-validated-number-input
      [id]="'c7PlusCorrelations'"
      [control]="control('c7PlusCorrelations')"
      [value]="control('c7PlusCorrelations').value"
      [validation]="{ min: 0, max: 10000000 }"
    ></app-validated-number-input>
  </div>

</form>